import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { useTenant } from "../Routers/TenantContextProvider";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

interface EnrolledStudent {
  givenName: string;
  middlename: string;
  surname: string;
  email: string;
  contactNo: string;
  gender: string;
  address: string | null;      // CHANGED
  suburb: string | null;       // CHANGED
  postcode: string | null;     // CHANGED
  schoolName: string;
  schoolGrade: string;
  dateOfBirth: string;
  id: number;
  status: string;
  actioned_by: string;
  created_at: string;
  updated_at: string;
  enrolmentMode: string;       // NEW
}

const RegisterEnrolledStudent = () => {
  const [enrolledStudents, setEnrolledStudents] = useState<EnrolledStudent[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const { tenant, loading, error } = useTenant();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  const formatDateTime = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy hh:mm a'); // Format: DD/MM/YYYY HH:MM am/pm
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy'); // Format: DD/MM/YYYY
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch enrolled students when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchEnrolledStudents();
    }
  }, [selectedTenant]);

  const fetchEnrolledStudents = async () => {
    if (!selectedTenant) return;

    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/enrolments`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setEnrolledStudents(response.data);
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  const handleReviewEnrolment = (enrolment_id: number) => {
    // Placeholder function
   // navigate(`/coaching/admin/dashboard/register-enrolled-student/review-enrolment/${enrolment_id}`);

    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/register-enrolled-student/review-enrolment/${enrolment_id}`);
    }
  };

    const handleAddNewEnrolment = () => {

    const enrolment_id=0;
    if (tenant)
    {
       navigate(`/platform/${tenant.tenant_slug}/app/register-enrolled-student/review-enrolment/${enrolment_id}`);
    }
  };


  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Register Enrolled Students</Heading>
      </VStack>

        <Box mt={4}>
            <Text fontWeight="bold">Enrolled Students</Text>
          <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewEnrolment}>
            + Student Enrolment
          </Button>
  </Box>


      <Box mt={4}>
        <Text fontWeight="bold">Enrolled Students Details</Text>
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Name</Th>
              <Th>Gender</Th>
              <Th>DoB</Th>
              <Th>Email</Th>
              <Th>Address</Th>
              <Th>Grade</Th>
              <Th>School</Th>
              <Th>Queue</Th>
              <Th>Mode</Th>
              <Th>Created At</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {enrolledStudents.map((enrolledStudent) => (
              <Tr key={enrolledStudent.id}>
                <Td>{enrolledStudent.id}</Td>
                <Td>{`${enrolledStudent.givenName} ${enrolledStudent.middlename} ${enrolledStudent.surname}`}</Td>
                <Td>{`${enrolledStudent.gender}`}</Td>
                <Td>{`${formatDate(enrolledStudent.dateOfBirth)}`}</Td>
                <Td>{`${enrolledStudent.email}`}</Td>
                <Td>
                  {enrolledStudent.address
                      ? `${enrolledStudent.address} ${enrolledStudent.suburb} ${enrolledStudent.postcode}`
                      : "—"}
                  </Td>
                <Td>{`${enrolledStudent.schoolGrade}`}</Td>
                <Td>{`${enrolledStudent.schoolName}`}</Td>
                <Td>{`${enrolledStudent.status}`}</Td>
                <Td>{enrolledStudent.enrolmentMode}</Td>   {/* NEW */}
                <Td>{`${formatDateTime(enrolledStudent.created_at)}`}</Td>
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewEnrolment(enrolledStudent.id)}>
                      Review & Register
                    </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default RegisterEnrolledStudent;
